import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { NetworkObserverService } from '../services/network';

// TODO - Hybrid App - this is probably not a final version of this guard, added for testing

export const noNetworkGuard = (): Observable<boolean | UrlTree> => {
  const networkObserver = inject(NetworkObserverService);
  const router = inject(Router);

  return networkObserver.connectionStatus$.pipe(
    map((status) => {
      if (status.connected) {
        return router.createUrlTree(['/']);
      }

      return true;
    }),
  );
};
